/**
 * @fileoverview Shared TanStack Query client.
 * @module app/query-client
 * @description
 * Single shared QueryClient for the app with modest defaults: limited retries
 * and a short stale time so data stays reasonably fresh without refetch storms.
 *
 * @author Liraz Amir
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000, // 30s — treat data as fresh briefly to avoid refetch churn.
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
